import React from 'react';

const AssignTaskTypeCategory = React.lazy(() => import('pages/AssignTaskType/AssignTaskTypeCategory'));
const AssignTaskTypeCategoryAdd = React.lazy(() => import('pages/AssignTaskType/AssignTaskTypeCategoryAdd'));
const AssignTaskTypeCategoryEdit = React.lazy(() => import('pages/AssignTaskType/AssignTaskTypeCategoryEdit'));
const AssignTaskTypeCategoryDetail = React.lazy(() => import('pages/AssignTaskType/AssignTaskTypeCategoryDetail'));

const assignTaskTypeRoutes = [
  {
    path: '/assign-task-type-category',
    exact: true,
    name: 'Danh sách loại công việc',
    function: 'ASSIGN_TASK_TYPE_VIEW',
    component: AssignTaskTypeCategory,
  },
  {
    path: '/assign-task-type-category/add',
    exact: true,
    name: 'Thêm mới loại công việc',
    function: 'ASSIGN_TASK_TYPE_ADD',
    component: AssignTaskTypeCategoryAdd,
  },
  {
    path: '/assign-task-type-category/detail/:id',
    exact: true,
    name: 'Chi tiết loại công việc',
    function: 'ASSIGN_TASK_TYPE_VIEW',
    component: AssignTaskTypeCategoryDetail,
  },
  {
    path: '/assign-task-type-category/edit/:id',
    exact: true,
    name: 'Chỉnh sửa loại công việc',
    function: 'ASSIGN_TASK_TYPE_EDIT',
    component: AssignTaskTypeCategoryEdit,
  },
];

export default assignTaskTypeRoutes;
